namespace GeniuzPOS.ReportMasterData {
    export class Report_1503Columns {
        static columnsKey = 'ReportMasterData.Report_1503';
    }
}
